import { useFlag } from "@mindlercare/unleash-client";
import CONSTANTS from "core/constants";
import { useTranslation } from "react-i18next";
import { Typography } from "components/typography";
import { Spacing, RadioGroup } from "@mindlercare/ui-web";
import { useEffect } from "react";

type AbsenceStatusProps = {
  value: string | null | undefined;
  setAbsenceStatus: (absenceStatus: string) => void;
  psychologistValidation: string[];
};

export const AbsenceStatusSection = ({
  value,
  setAbsenceStatus,
  psychologistValidation,
}: AbsenceStatusProps) => {
  const { t } = useTranslation();
  const hasError = psychologistValidation.includes("absenceStatus");
  const hide = useFlag("HIDE_MC_PSYCHOLOGIST_STATUSES");

  // Set default value if none exists
  useEffect(() => {
    if (!value) {
      setAbsenceStatus(CONSTANTS.PSYCHOLOGIST.ABSENCE_STATUS.ACTIVE);
    }
  }, [value, setAbsenceStatus]);

  if (hide) return null;

  return (
    <div>
      <Typography
        variant="body-x-small"
        color={hasError ? "ERROR" : "GRAY_DARK"}
        insensitive
      >
        {`${t("STATUS")}* (${t("PSYCHOLOGIST_STATUSES.ONLY_VISIBLE_BY_CS_AND_ADMIN")})`}
      </Typography>

      <Spacing t={12} />

      <RadioGroup
        defaultValue={value ?? CONSTANTS.PSYCHOLOGIST.ABSENCE_STATUS.ACTIVE}
        aria-labelledby="psychologist-absence-status-label"
        onChange={(currentValue) => {
          setAbsenceStatus(currentValue);
        }}
      >
        <RadioGroup.RadioButton
          name={CONSTANTS.PSYCHOLOGIST.ABSENCE_STATUS.ACTIVE}
        >
          <span>{t("PSYCHOLOGIST_STATUSES.ABSENCE_STATUS_ACTIVE")}</span>
        </RadioGroup.RadioButton>
        <RadioGroup.RadioButton
          name={CONSTANTS.PSYCHOLOGIST.ABSENCE_STATUS.ON_LEAVE}
        >
          <span>{t("PSYCHOLOGIST_STATUSES.ABSENCE_STATUS_ON_LEAVE")}</span>
        </RadioGroup.RadioButton>
      </RadioGroup>
    </div>
  );
};
